import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import ImageX from "components/utility/images/ImageX";
import { getDecodedHtml } from "utils/getDecodedHtml";

class HeaderPersistentBar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			closed: false,
			submitting: false
		};
		this.containerRef = React.createRef();
	}

	componentDidMount() {
		if (this.props.data && this.props.type === "bottom") {
			this.onResize();
			window.addEventListener("resize", this.onResize);
		}

		if (this.props.data !== undefined && this.props.data !== null) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				"data-a-lbl": "Banner Initiated",
				"data-a-cat": "Redirect Banner",
				"data-a-act":
					"Visiting " +
					this.props.data.visitingCountryCode +
					", Previously " +
					this.props.data.currentCountryCode
			});
		}
	}

	onResize() {
		const bottomPersistentBar = document.querySelector(".header-persistent-bar-bottom");
		const topPersistentBar = document.querySelector(".header-persistent-bar-top");
		const firstLogin = document.querySelector(".header-persistent-bar-without-line");
		if (window.innerWidth < 768) {
			if (topPersistentBar && bottomPersistentBar) {
				bottomPersistentBar.style.top = "auto";
			}
		} else {
			const placeholder = document.querySelector(".header-persistent-bar-bottom-placeholder");
			placeholder.insertAdjacentElement("afterend", bottomPersistentBar);
			if (topPersistentBar && bottomPersistentBar && firstLogin) {
				bottomPersistentBar.style.top = topPersistentBar.clientHeight + "px";
			}
		}
	}
	onClose = (e) => {
		e.preventDefault();
		this.post(
			"SESSION",
			() => {
				this.setState({
					closed: true,
					submitting: false
				});
				this.adjustStickyHeader(false);
			},
			() => {
				this.setState({
					closed: true,
					submitting: false
				});
				this.adjustStickyHeader(false);
			}
		);
	};
	onCta = (e) => {
		e.preventDefault();
		this.post(
			"PERMANENT",
			() => {
				this.setState({
					closed: true,
					submitting: false
				});
				this.adjustStickyHeader(true);
			},
			() => {
				this.setState({
					closed: true,
					submitting: false
				});
				this.adjustStickyHeader(true);
			}
		);
	};
	setCountryCookie = (e) => {
		this.onClose(e);
		fetch(this.props.data.countryAPIEndpoint, {
			credentials: "same-origin",
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json"
			},
			body: JSON.stringify({ countryValue: this.props.data.countryValue })
		})
			.then((res) => res.json())
			.catch((error) => {
				console.log(error);
			});
	};
	adjustStickyHeader(redirect) {
		const persistentBar = this.containerRef.current;
		const hardHeight = persistentBar.offsetHeight + "px";
		persistentBar.style.height = hardHeight;
		setTimeout(() => {
			if (persistentBar.classList.contains("header-persistent-bar-top")) {
				const firstPlaceholder = document.querySelector(".sticky-header-placeholder");
				const firstStickyEl = document.querySelector(".sticky-header-el");
				if (firstPlaceholder) {
					firstPlaceholder.style.height =
						firstStickyEl.offsetHeight - persistentBar.offsetHeight + "px";
				}
			}

			persistentBar.style.height = "0px";

			if (redirect) {
				setTimeout(() => {
					if (this.props.data.ctaUrl && this.props.data.ctaUrl.length) {
						if (this.props.data.ctaTarget && this.props.data.ctaTarget.length) {
							window.open(this.props.data.ctaUrl, this.props.data.ctaTarget);
						} else {
							window.location = this.props.data.ctaUrl;
						}
					}
				}, 400);
			}
		}, 50);
	}
	post(acceptanceType, success, error) {
		if (!this.state.submitting) {
			this.setState({ submitting: true });
			fetch(this.props.data.url, {
				credentials: "same-origin",
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json"
				},
				body: JSON.stringify({ notificationId: this.props.data.notificationId, acceptanceType })
			})
				.then((res) => res.json())
				.then(success)
				.catch(error);
		}
	}
	render() {
		if (!this.props.data) {
			return "";
		}

		const { color, type, data, dataset } = this.props;
		const {
			countryFlag = false,
			setCountryCookieText,
			ctaText,
			ctaUrl,
			visitingCountryCode,
			currentCountryCode
		} = data;
		const { withoutLine = false, publicSite = false } = dataset;
		let button = null,
			closeButton = null,
			bottomPlaceholder = null;
		if (ctaText && ctaUrl) {
			button = data.countryFlag ? (
				<div className="header-persistent-bar-button header-persistent-bar-button-right">
					<button
						className="header-persistent-bar-set-country-cookie"
						aria-label={setCountryCookieText}
						onClick={(e) => this.setCountryCookie(e)}
						data-a="true"
						data-a-lbl={setCountryCookieText}
						data-a-cat="Banner"
						data-a-act={"Visiting " + visitingCountryCode + ", Previously " + currentCountryCode}
					>
						{setCountryCookieText}
					</button>
					<a
						className="header-persistent-bar-stay"
						href={ctaUrl}
						aria-label={ctaText}
						data-a="true"
						data-a-lbl={ctaText}
						data-a-cat="Banner"
						data-a-act={"Visiting " + visitingCountryCode + ", Previously " + currentCountryCode}
					>
						{ctaText}
					</a>
				</div>
			) : (
				<div className="header-persistent-bar-button">
					<a
						className=""
						href={ctaUrl}
						aria-label={data.ctaText}
						data-a="true"
						data-a-lbl={ctaText}
						data-a-cat="Banner"
						data-a-act={"Visiting " + visitingCountryCode + ", Previously " + currentCountryCode}
					>
						{ctaText}
					</a>
				</div>
			);
		}
		if (data.showCloseButton) {
			closeButton = (
				<a
					className="header-persistent-bar-close"
					href="/"
					onClick={this.onClose}
					aria-label="close"
				>
					<ImageX />
				</a>
			);
		}
		if (type === "bottom") {
			bottomPlaceholder = <div className="header-persistent-bar-bottom-placeholder"></div>;
		}
		return (
			<Fragment>
				{bottomPlaceholder}
				<div
					className={
						"container header-persistent-bar" +
						(color ? " header-persistent-bar-" + color : "") +
						(type ? " header-persistent-bar-" + type : "") +
						(withoutLine === "true" && !publicSite ? " header-persistent-bar-full-width" : "") +
						(publicSite ? " header-persistent-bar-public" : "")
					}
					ref={this.containerRef}
				>
					<div
						className={
							"grid" + (withoutLine === "true" ? " header-persistent-bar-without-line" : "")
						}
					>
						<div
							className={
								"header-persistent-bar-content" +
								(data.showCloseButton ? "" : " header-persistent-bar-content-regular-padding") +
								(countryFlag ? " header-persistent-bar-content-country-flag" : "")
							}
						>
							<div
								className="header-persistent-bar-rte"
								dangerouslySetInnerHTML={{ __html: getDecodedHtml(data.text) }}
							/>
							{button}
							{closeButton}
						</div>
					</div>
				</div>
			</Fragment>
		);
	}
}

HeaderPersistentBar.propTypes = {
	color: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
	dataset: PropTypes.object
};

export default HeaderPersistentBar;
